// Packages
//import { useSelector } from 'react-redux';

// Component
import SchoolGroupsComponents from "../../component/schoolAdminPortal/schoolGroups";

function Index() {
  return (
    <div>
      <SchoolGroupsComponents />
    </div>
  );
}

export default Index;
